
// NOTE THIS IS THE FUNCTIONALITY FROM THE OLD SITE WRITTEN IN JQUERY TO PLAIN JAVASCRIPT.
document.addEventListener('tomitLoaded', () => {
   document.querySelector('.btn-find-in-store').classList.add('active');
});

document.addEventListener('jtcVariantLocationsLoaded', (e) => {
   let closeButton = document.querySelector('.close-popup');
   if (closeButton) {
      closeButton.addEventListener('click', (e) => {
         document.querySelector('.find-in-store-wrapper').classList.remove('active');
         document.querySelector('html').classList.remove('active-popup');
         document.querySelector('body').classList.remove('active-popup');
         e.preventDefault();
      })
   } else {
      console.error('closeButton wasnt rendered on page yet.')
   }
});

// jQuery(document).ready(function() {}
document.querySelector('.inventory-actions a.add-to-cart').addEventListener('click', () => {
  document.querySelector('.find-in-store-wrapper').classList.remove('active');
  document.querySelector('html').classList.remove('active-popup');
  document.querySelector('body').classList.remove('active-popup');
  // maybe we add a classe name to this doesnt grab wrong button?
  document.querySelector('button.relative.w-full.uppercase.button-primary').click();
  e.preventDefault();
})

document.querySelector('.btn-find-in-store').addEventListener('click', (e) => {
  // old form =  #AddToCartForm-product
  // var form = document.querySelector('.product-left');
  // dont use this in the new theme
  // var select = form.getAttribute('data-selected');
  // if (select == 'false'){
  //    console.warn('form not selected');
  //    document.querySelector('.size-error').show();
  //    return false;
  // }
  let isSelected = true
  let error = document.querySelector('#find-in-store-error')
  let size = document.querySelectorAll('#product-left > product-form  .js-product-form .dropdown span').forEach((selector) => {
      let content = selector.innerHTML.toLowerCase()
      if (content  === 'select size') {
        isSelected = false
      }
  });
  if (!isSelected) {
      console.warn('size not selected');
      if (!error) { return false }
      error.innerHTML = 'Please select a size'
      return false
  }
  else {
      if (error) { error.innerHTML = '' }
      document.querySelector('.inventory-content').replaceChildren();
      // maybe need to change this to check the child nodes?
      // if($('#tomit_inventory_list').length)
      if (document.querySelector('#tomit_inventory_list').childElementCount) {
        //Update variant detail
        document.querySelector('.variant-detail').replaceChildren();
        // price = $('.product-price-section .product__price').prop('outerHTML')
        let price = document.querySelector('#product-left div.product-price > p').innerHTML
        let img = document.querySelector('#product-details product-gallery > carousel-main .carousel-track > div:nth-child(1) > div > picture > img').src

        document.querySelector('.find-in-store-wrapper .media img').setAttribute('src', img);
        document.querySelectorAll('#product-left > product-form .js-product-form  .dropdown  span:nth-child(2').forEach((selector) => {
            // need to trim whitespaces here
            // let label = selector.querySelector('.select-with-style-label').innerHTML;
            // let content = selector.querySelector('.current-select-value').innerHTML;
            let content = selector.innerHTML
            let contentDOM = document.createElement('li');
            contentDOM.append(content)
            // old: document.querySelector('.variant-detail').append('<li><strong>'+ label +'</strong>'+ content +'</li>');
            document.querySelector('.variant-detail').append(contentDOM);
        });

        // '<li><strong>PRICE</strong>'+ price +'</li>'
        let priceDOM = document.createElement('li');
        let priceTitle = document.createElement('strong')
        priceTitle.innerHTML = 'PRICE'
        priceDOM.append(priceTitle)
        priceDOM.append(price)
        document.querySelector('.variant-detail').append(priceDOM);

        // Update stock
        let stock = false;
        let stock2 = false;

        document.querySelectorAll('#tomit_inventory_list li').forEach((list) => {
            let store = list.querySelector('.location').innerHTML.toLowerCase()
            let stockCount = list.querySelector('.stockCount').innerHTML.trim()
            stockCount = parseInt(stockCount)
            // if error set to out of stock?
            if (!stockCount) { stockCount = 0 }
            let stockText = '';

            if (stockCount > 0) { stock2 = true;}
            switch(stockCount) {
              case 0:
                stockText = 'No Stock';
                break;
              case 1:
                stockText = 'Last One';
                break;
                case 2:
                stockText = 'Low Stock';
                break;
              default:
                stockText = 'In Stock';
            }

            // TODO: the settings object isnt currently set up for this and the section isnt rending the right data structure
            // Data was pulled in similarly in the old theme.
            let findInStoreData = null
            //  let findInStoreData = document.querySelector('script[findInStoreData=""]');
            //  if (findInStoreData) {
            //    findInStoreData = JSON.parse(findInStoreData.innerHTML);
            //  } else {
            //    console.warn('Could not find store data');
            //  }
          if (store.indexOf("paddington") >= 0) {
            if (stockCount > 0) { stock = true;}
            // <ul class="inventory-table"> {items} </ul>
            let item = document.createElement('ul');
            item.classList.add('inventory-table')
            // column 1: <li class="heading inventory-column-1">ARMADALE<span class="armadale-info-store">{{ settings.armadale_address }}</span></li>
            let listItem = document.createElement('li');
            listItem.classList.add('heading', 'inventory-column-1');
            listItem.innerHTML = 'PADDINGTON'
            let storeInfo = document.createElement('span');
            storeInfo.classList.add('paddington-info-store');
            storeInfo.innerHTML = findInStoreData ? findInStoreData?.armadale?.address : '108 Oxford Street, Paddington, NSW, 2021'
            listItem.append(storeInfo);
            item.append(listItem)
            // column 2: <li class="heading inventory-column-2">'+ stockText +'</li>
            listItem = document.createElement('li');
            listItem.classList.add('heading', 'inventory-column-2');
            listItem.innerHTML = stockText
            item.append(listItem)
            // column 3: <li class="heading inventory-column-3"><span class="armadale-phone-store">{{ settings.armadale_phone }}</span></li>
            listItem = document.createElement('li');
            listItem.classList.add('heading', 'inventory-column-3');
            storeInfo = document.createElement('span');
            storeInfo.classList.add('paddington-phone-store');
            storeInfo.innerHTML = findInStoreData ? findInStoreData?.armadale?.phone : '02 8323 7229'
            listItem.append(storeInfo);
            item.append(listItem)
            // add to popup
            document.querySelector('.inventory-content').append(item);
          }

            if (store.indexOf("armadale") >= 0) {
              if (stockCount > 0) { stock = true;}
              // <ul class="inventory-table"> {items} </ul>
              let item = document.createElement('ul');
              item.classList.add('inventory-table')
              // column 1: <li class="heading inventory-column-1">ARMADALE<span class="armadale-info-store">{{ settings.armadale_address }}</span></li>
              let listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-1');
              listItem.innerHTML = 'ARMADALE'
              let storeInfo = document.createElement('span');
              storeInfo.classList.add('armadale-info-store');
              storeInfo.innerHTML = findInStoreData ? findInStoreData?.armadale?.address : '1038 High Street, Armadale, VIC, 3143'
              listItem.append(storeInfo);
              item.append(listItem)
              // column 2: <li class="heading inventory-column-2">'+ stockText +'</li>
              listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-2');
              listItem.innerHTML = stockText
              item.append(listItem)
              // column 3: <li class="heading inventory-column-3"><span class="armadale-phone-store">{{ settings.armadale_phone }}</span></li>
              listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-3');
              storeInfo = document.createElement('span');
              storeInfo.classList.add('armadale-phone-store');
              storeInfo.innerHTML = findInStoreData ? findInStoreData?.armadale?.phone : '03 9500 9075'
              listItem.append(storeInfo);
              item.append(listItem)
              // add to popup
              document.querySelector('.inventory-content').append(item);
            }

            if (store.indexOf("brighton") >= 0) {
              if (stockCount > 0){ stock = true;}
              // <ul class="inventory-table"> {items} </ul>
              let item = document.createElement('ul');
              item.classList.add('inventory-table')
              // column 1: <li class="heading inventory-column-1">BRIGHTON<span class="brighton-info-store">{{ settings.brighton_address }}</span></li>
              let listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-1');
              listItem.innerHTML = 'BRIGHTON'
              let storeInfo = document.createElement('span');
              storeInfo.classList.add('brighton-info-store');
              storeInfo.innerHTML = findInStoreData ? findInStoreData?.brighton?.address : '121 Church Street, Brighton, VIC, 3186'
              listItem.append(storeInfo);
              item.append(listItem)
              // column 2: <li class="heading inventory-column-2">'+ stockText +'</li>
              listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-2');
              listItem.innerHTML = stockText
              item.append(listItem)
              // column 3: <li class="heading inventory-column-3"><span class="brighton-phone-store">{{ settings.brighton_phone }}</span></li>
              listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-3');
              storeInfo = document.createElement('span');
              storeInfo.classList.add('brighton-phone-store');
              storeInfo.innerHTML = findInStoreData ? findInStoreData?.brighton?.phone : '03 8525 7210'
              listItem.append(storeInfo);
              item.append(listItem)
              // add to popup
              document.querySelector('.inventory-content').append(item);
            }

            if (store.indexOf("james") >= 0) {
              if (stockCount > 0){ stock = true;}
              // <ul class="inventory-table"> {items} </ul>
              let item = document.createElement('ul');
              item.classList.add('inventory-table')
              let listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-1');
              listItem.innerHTML = 'JAMES STREET'
              let storeInfo = document.createElement('span');
              storeInfo.classList.add('james-street-info-store');
              storeInfo.innerHTML = findInStoreData ? findInStoreData?.james_street?.address : '48 James Street, Fortitude Valley, QLD, 4006'
              listItem.append(storeInfo);
              item.append(listItem)
              // column 2: <li class="heading inventory-column-2">'+ stockText +'</li>
              listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-2');
              listItem.innerHTML = stockText
              item.append(listItem)
              listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-3');
              storeInfo = document.createElement('span');
              storeInfo.classList.add('james-street-phone-store');
              storeInfo.innerHTML = findInStoreData ? findInStoreData?.james_street?.phone : '07 3112 8951'
              listItem.append(storeInfo);
              item.append(listItem)
              // add to popup
              document.querySelector('.inventory-content').append(item);
            }

            if (store.indexOf("residency") >= 0) {
              if (stockCount > 0){ stock = true;}
              let item = document.createElement('ul');
              item.classList.add('inventory-table')
              let listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-1');
              listItem.innerHTML = 'TNT RESIDENCY'
              let storeInfo = document.createElement('span');
              storeInfo.classList.add('tnt-residency-info-store');
              storeInfo.innerHTML = '1071 High Street, Armadale, VIC, 3143'
              listItem.append(storeInfo);
              item.append(listItem)
              listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-2');
              listItem.innerHTML = stockText
              item.append(listItem)
              listItem = document.createElement('li');
              listItem.classList.add('heading', 'inventory-column-3');
              storeInfo = document.createElement('span');
              storeInfo.classList.add('tnt-residency-phone-store');
              storeInfo.innerHTML = '03 9962 5443'
              listItem.append(storeInfo);
              item.append(listItem)
              document.querySelector('.inventory-content').append(item);
            }
        })

        // Update call to action
        let inventoryActions = document.querySelector('.inventory-actions')
        // $('.inventory-actions').removeClass()
        inventoryActions.className = 'inventory-actions'
        if (stock) {
            inventoryActions.classList.add('stock');
        } else {
            if (stock2) {
              inventoryActions.classList.add('shop-online-now');
            } else{
              inventoryActions.classList.add('sold-out');
            }
        }

        // Show popup
        document.querySelector('.find-in-store-wrapper').classList.add('active');
        document.querySelector('html').classList.add('active-popup');
        document.querySelector('body').classList.add('active-popup');
      }
  }

  e.preventDefault();
})
